export class CompanyTmsRole {
    public id: number | null;
    public company_id: number | null;
    public tms_role_id: number| null;
    public send_to_c4web_yn: string| null;
    public date_from: Date|null;

    constructor(data: CompanyTmsRoleData | undefined | null = undefined) {
        if (data === undefined || data === null) {
            this.id = null;
            this.company_id = null;
            this.tms_role_id = -1;
            this.send_to_c4web_yn = "";
            this.date_from = null;
        }
        else {
            this.id = data.id;
            this.tms_role_id = data.tms_role_id;
            this.company_id = data.company_id;
            this.send_to_c4web_yn = data.send_to_c4web_yn;
            this.date_from = data.date_from;
        }

    }

    serializeData():CompanyTmsRoleData {
        return {
            id: this.id,
            company_id: this.company_id,
            tms_role_id: this.tms_role_id,
            send_to_c4web_yn: this.send_to_c4web_yn,
            date_from: this.date_from,
        }
    }
}

export type CompanyTmsRoleData = {
    id: number | null;
    company_id: number | null;
    tms_role_id: number| null;
    send_to_c4web_yn: string| null;
    date_from: Date| null;
}
